var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('staff-form',{model:{value:(_vm.staff),callback:function ($$v) {_vm.staff=$$v},expression:"staff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }